import React from 'react';
import { CircularProgress } from '@material-ui/core';

export const Loader = props => <CircularProgress size={20} {...props} />;
